// export constants that we use in the rest of the program to avoid working with strings.
export const setProgramsQuery = "setProgramsQuery"
export const setProgramsRoFQuery = "setProgramsRoFQuery"
export const setProgramsQueryProviders = "setProgramsQueryProviders"
export const setProgramsResults = "setProgramsResults"
export const setProgramsHaveSelectedRow = "setProgramsHaveSelectedRow"
export const setProgramsColumnTypes = "setProgramsColumnTypes"
export const setProgramsInitStatus = "setProgramsInitStatus"
export const setProgramsQueryForAPI = "setProgramsQueryForAPI"
export const setProgramsExportQuery = "setProgramsExportQuery"
export const setProgramsRoFResults = "setProgramsRoFResults"
export const setProgramsRoFResultsTableData = "setProgramsRoFResultsTableData"
export const setProgramsChannels = "setProgramsChannels"
export const setProgramsProviders = "setProgramsProviders"
export const setProgramsStartdate = "setProgramsStartdate"
export const setProgramsEnddate = "setProgramsEnddate"
export const setProgramsPubStartdate = "setProgramsPubStartdate"
export const setProgramsPubEnddate = "setProgramsPubEnddate"
export const setProgramsSearchForPubDate = "setProgramsSearchForPubDate"
export const setProgramsGenres = "setProgramsGenres"
export const setProgramsDefaultColumns = "setProgramsDefaultColumns"
export const setProgramsAllWithStarSelected = "setProgramsAllWithStarSelected"
export const setProgramsWeekdays = "setProgramsWeekdays"
export const setTopProgramsLatestDay = "setTopProgramsLatestDay"
export const setQueryCostData = "setProgramsQueryCostData"
export const setQueryCostLoading = "setProgramsQueryCostLoading"
export const setQueryCostError = "setProgramsQueryCostError"
export const setProgramsQueryBeforeChange = "setProgramsQueryBeforeChange"
export const setProgramsStringForFilterBeforeChange = "setProgramsStringForFilterBeforeChange"
export const setProgramsHasExcludedRow = "setProgramsHasExcludedRow"
export const setProgramsSumVisible = "setProgramsSumVisible"
export const setProgramsQueryDefault = "setProgramsQueryDefault"
export const setProgramsHasSetDefaultQuery = "setProgramsHasSetDefaultQuery"